import { useState } from "react";
import { Input } from "reactstrap";

const Tableth = ({
  initialTask,
  initialEmail,
  initialPhone,
  initialAssign,
  initialDate,
  initialPrice,
  initialStatus,
  initialProgress,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [task, setTask] = useState(initialTask);
  const [email, setEmail] = useState(initialEmail);
  const [phone, setPhone] = useState(initialPhone);
  const [assign, setAssign] = useState(initialAssign);
  const [date, setDate] = useState(initialDate);
  const [price, setPrice] = useState(initialPrice);
  const [status, setStatus] = useState(initialStatus);
  const [progress, setProgress] = useState(initialProgress);

  const editHandler = () => {
    setIsEditing((isEditing) => !isEditing);
  };

  return (
    <>
      <tr onClick={editHandler}>
        <td>
          {isEditing ? (
            <Input
              type="text"
              value={task}
              onChange={(e) => {
                setTask(e.target.value);
              }}
            />
          ) : (
            task
          )}
        </td>
        <td>
          {isEditing ? (
            <Input
              type="text"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          ) : (
            email
          )}
        </td>
        <td>
          {isEditing ? (
            <Input
              type="text"
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
            />
          ) : (
            phone
          )}
        </td>
        <td>
          {isEditing ? (
            <Input
              type="text"
              value={assign}
              onChange={(e) => {
                setAssign(e.target.value);
              }}
            />
          ) : (
            assign
          )}
        </td>
        <td>
          {isEditing ? (
            <Input
              type="text"
              value={date}
              onChange={(e) => {
                setDate(e.target.value);
              }}
            />
          ) : (
            date
          )}
        </td>
        <td>
          {isEditing ? (
            <Input
              type="text"
              value={price}
              onChange={(e) => {
                setPrice(e.target.value);
              }}
            />
          ) : (
            price
          )}
        </td>
        <td>
          {isEditing ? (
            <Input
              type="text"
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
              }}
            />
          ) : (
            status
          )}
        </td>
        <td>
          {isEditing ? (
            <Input
              type="text"
              value={progress}
              onChange={(e) => {
                setProgress(e.target.value);
              }}
            />
          ) : (
            progress
          )}
        </td>
        <th className="jsgrid-cell jsgrid-control-field jsgrid-align-center">
          <div className="jsgrid-align-center">
            <div className="align-items-center d-flex gap-2 justify-content-center ">
              {isEditing? 
             <>
             <Input
               type="button"
               className="jsgrid-button jsgrid-update-button"
               title="Edit"
             />
             <Input
               type="button"
               className="jsgrid-button jsgrid-cancel-edit-button"
               title="Delete"
             />
             </>
              :
              <>
              <Input
                type="button"
                className="jsgrid-button jsgrid-edit-button"
                title="Edit"
              />
              <Input
                type="button"
                className="jsgrid-button jsgrid-delete-button"
                title="Delete"
              />
              </>
               
               }
            </div>
          </div>
        </th>
      </tr>
    </>
  );
};

export default Tableth;
